import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { Scheduler, Button, SelectBox } from "devextreme-react";
// import * as signalR from '@aspnet/signalr';
import {
  doGetBlockingsAppointments,
  setHideShowWizard,
  setStepWizard,
  doGetWeekAppointments,
  doGetCenters,
  setCenterIdBlocking,
  doGetQuotesList,
  doGetCenterConfiguration,
  doGetDataToUpdateWeek,
  doGetListConfigurations,
  openCloseModalDeleteBlocking,
  doGetDataToUpdateBlocking,
  resetState,
  doGetOpeningData,
  doEditOpeningData,
  loadBlockReason,
  loading,
  deleteBlock,
  resetBlockingState
} from "./actions";

import ModalDeleteBlocking from "./ModalDeleteBlocking";

import { showToastError, showToastSuccess } from "../../../../Main/actions";
import ModalWizard from "./wizard/modal";
import { CuposItem } from "./cuposItem";
import { numberToDay } from "../../../../../helpers/strings";
import validaciones from "../../../../../helpers/validaciones";
import moment from "moment"
import config from "../../../../../config/api";

const mes = "Mes";
const semana = "Semana";
const dia = "Dia";
const defaultStartHour = "07:00";
const defaultEndHour = "20:00";
const defaultInterval = 15;

class BlockingScheduler extends React.Component {
  constructor(props) {
    super(props);
    this.cellClick = null;
    this.currentView = mes;
    this.currentDate = new Date();
    this.lastTimeInterval = "";
    this.state = {
      connectionHub: null,
    };
  }

  componentDidMount = () => {
    if (this.props.centrosList && this.props.centrosList.length === 0) this.props.dispatch(doGetCenters());
    if (!this.props.listaAppointments) this.props.dispatch(doGetBlockingsAppointments(this.props.centerId));
    //if (this.props.listQuotes && this.props.listQuotes.length === 0) this.props.dispatch(doGetQuotesList());
  }

  componentWillUnmount = () => {
    this.props.dispatch(resetState())
  }

  shouldComponentUpdate = (nextProps) => {
    if (this.props.blocking !== nextProps.blocking) return false;
    return true;
  }

  handleStartSignalR = (data, isDelete) => {
    // const _connectionHub = new signalR.HubConnectionBuilder()
    //     .withUrl(config.WebSocketUrl, { accessTokenFactory: () => this.props.tokenJwt })
    //     .configureLogging(signalR.LogLevel.Information)
    //     .build();

    // _connectionHub.start()
    // .then(() => {
    //   this.setState({connectionHub: _connectionHub}, () => {
    //     if(isDelete){
    //       this.props.dispatch(openCloseModalDeleteBlocking(true, data));
    //     }else{
    //       if(data){
    //         this.props.dispatch(doEditOpeningData(data))
    //         this.props.dispatch(loadBlockReason())
    //       }else{
    //         this.openNewBlocking()
    //       }
    //     }

    //     if(this.state.connectionHub){
    //       //this.state.connectionHub.off('schedulingReceived')
    //       this.state.connectionHub.on('schedulingReceived',(data) => {
    //         if(data.TypeView === 2 && data.Rut === this.props.userData.RUT){
    //           if(data.Success === true){
    //             if(data.IsReserve === true){
    //               this.props.dispatch(doGetBlockingsAppointments(this.props.centerId));
    //               this.props.dispatch(setHideShowWizard(false));
    //               this.props.dispatch(showToastSuccess(`Se ha creado/modificado el bloqueo correctamente.`));
    //             }else if(data.IsDelete === true){
    //               this.props.dispatch(openCloseModalDeleteBlocking(false, null));
    //               this.props.dispatch(doGetBlockingsAppointments(this.props.centerId));
    //               this.props.dispatch(showToastSuccess(`Se ha eliminado el bloqueo correctamente.`));
    //             }
    //           } else if(data.error){
    //             this.props.dispatch(showToastError(data.error))
    //             this.props.dispatch(loading(false))
    //           }else{
    //             this.props.dispatch(showToastError())
    //             this.props.dispatch(loading(false))
    //           }
    //         }
    //       })
    //     }
    //   })
    // })
    // .catch((err) => {
    //   console.error('SignalR Connection 2 Error: ', err);
    // });
  }

  handleStopSignalR = () => {
    // this.props.dispatch(resetBlockingState(this.props.centerId));
    // if(this.state.connectionHub){
    //   this.state.connectionHub.stop()
    // }
  }

  getNumber = (dateTime, max = false) => {
    const numbers = dateTime.split(":");
    let [number] = numbers;
    number = parseInt(number, 10);
    if (numbers[1] > 0 && max) {
      number += 1;
    }
    return number;
  }
  getFirstHour = () => {
    const { blocking } = this.props;
    const start = this.getNumber(blocking.startWorkDay || defaultStartHour);
    const startSat = this.getNumber(blocking.satWorkstart || defaultStartHour);
    const startSun = this.getNumber(blocking.sunWorkStart || defaultStartHour);
    return Math.min(start, startSat, startSun);
  }

  getLastHour = () => {
    const { blocking } = this.props;
    const end = this.getNumber(blocking.endWorkDay || defaultEndHour, true);
    const endSat = this.getNumber(blocking.satWorkEnd || defaultEndHour, true);
    const endSun = this.getNumber(blocking.sunWorkEnd || defaultEndHour, true);
    return Math.max(end, endSat, endSun);
  }

  getDataSource = () => {
    switch (this.currentView) {
      case semana: {
        return this.props.weekAppointments;
      }
      case dia: {
        return this.props.weekAppointments;
      }
      default: {
        return this.props.listaAppointments;
      }
    }
  }

  handleChange = (e) => {
    //this.props.dispatch(doGetCenterConfiguration(e.value));
    this.props.dispatch(setCenterIdBlocking(e.value));

    //this.loadWeekData();
    this.loadMothData();
  }

  handleAppointmentClick = (event) => {
    switch (this.currentView) {
      case semana: {
        event.cancel = true;
        this.props.dispatch(doGetDataToUpdateWeek(event.appointmentData));
        break;
      }
      case dia: {
        event.cancel = true;
        this.props.dispatch(doGetDataToUpdateWeek(event.appointmentData));
        break;
      }
      case mes: {
        break;
      }
      default: {
        break;
      }
    }
  }

  openNewBlocking = () => {
    if (this.props.blocking.IdCentro !== null) {
      //this.props.dispatch(doGetListConfigurations(this.props.blocking.IdCentro));
      this.props.dispatch(loadBlockReason())
      this.props.dispatch(setHideShowWizard(true));
      this.props.dispatch(setStepWizard({
        isNewApertura: true,
        stepOne: true,
        stepTwo: false,
        stepThree: false,
        stepFour: false,
        stepSuccess: false,
      }));
    } else {
      this.props.dispatch(showToastError("Debe seleccionar un centro antes de crear una bloqueo"));
    }
  }

  loadWeekData = (startDate) => {
    this.props.dispatch(doGetWeekAppointments(this.props.centerId, startDate));
  }

  loadDayData = (startDate) => {
    this.props.dispatch(doGetWeekAppointments(this.props.centerId, startDate));
  }

  loadMothData = (startDate) => {
    this.props.dispatch(doGetBlockingsAppointments(this.props.centerId, startDate));
  }

  handleDelete = (data) => {
    //this.props.dispatch(deleteBlock(arr, this.props.connectionHub))
    this.props.dispatch(openCloseModalDeleteBlocking(true, data));
  }

  handleEdit = (data) => {
    /*const listBlocking = [...this.props.listaAppointments];
    const blockingSelected = listBlocking.find((o) => o.Id === data.Id);
    this.props.dispatch(doGetListConfigurations(this.props.centerId));
    this.props.dispatch(doGetDataToUpdateBlocking(blockingSelected, this.props.centerId));*/
    this.props.dispatch(doEditOpeningData(data))
    this.props.dispatch(loadBlockReason())
  }

  handleOptionChange = (e) => {
    if (e.name === "currentDate" || e.name === "currentView") {
      this.currentView = e.component.option("currentView");
      this.currentDate = e.component.option("currentDate");
      switch (this.currentView) {
        case semana: {
          this.loadWeekData(this.currentDate);
          break;
        }
        case mes: {
          this.loadMothData(this.currentDate);
          break;
        }
        case dia: {
          this.loadDayData(this.currentDate);
          break;
        }
        default: {
          break;
        }
      }
    }
  }

  renderMonthItem = (data, index, element) => {
    if (data.Quotas) return;
    ReactDOM.render(
      <div className="blocking-view-month-text">
        {data.text}
      </div>
      , element
    );
  }

  renderWeekItem = (data, index, element) => {
    if (!data.Quotas) return;
    ReactDOM.render(
      <CuposItem data={data} />
      , element
    );
  }

  tooltipContentBox = (opt) =>  {
    if(!opt) return "";
    const _textQuantity = (text, isRed) => {
      return <div className={isRed ? "is-red" : "is-black"}>
        {text.toString()}
      </div>
    }
    return (<div
      className={`item-${opt.QuotaId}`}
      key={(opt.Description || "") + opt.QuotaId}>
        {_textQuantity(opt.QuantityQuotaScheduled, !!opt.QuantityQuotaConflict)}{"/"}{_textQuantity(opt.QuantityQuotaAvailable, !!opt.QuantityQuotaBlocked)}{" + "}{_textQuantity(opt.QuantityOverQuotaScheduled, !!opt.QuantityOverQuotaConflict)}{"/"}{_textQuantity(opt.QuantityOverQuotaAvailable, !!opt.QuantityOverQuotaBlocked)}
    </div>)
  };

  renderMonthTooltip = (data, element) => {
    ReactDOM.render(
      <div className="tooltip-bloqueos-mes">
        <div className="top-info">
          <div className="info">
            <span className="title">{data.text}</span>
            <div className="date">{`${new Date(data.BlockDate).toLocaleDateString()} - ${new Date(data.BlockEndDate).toLocaleDateString()}`}</div>
          </div>
          <div className="buttons">
            <Button className="edit-button" onClick={() => this.handleStartSignalR(data)}>
              <i className="material-icons">create</i>
            </Button>
            <Button className="delete-button" onClick={() => this.handleStartSignalR(data, true)}>
              <i className="material-icons">delete</i>
            </Button>
          </div>
        </div>
        <div className="dias-info">
          {data.TimeBlockedScheduling.map((item) => (
            <div key={`day-${item.Day}`} className="day">
              <div className="text">{moment(item.StartTime, "hh:mm:ss").format("HH:mm")+"-"+moment(item.EndTime, "hh:mm:ss").format("hh:mm")}</div>
              <div className="numbers">
                {item.BlockOpeningQuota.map((quota) => (
                  this.tooltipContentBox(quota)
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
      , element
    );
  }

  renderWeekTooltip = (data, element) => {
    ReactDOM.render(
      <div>
        cupos,
      </div>
      , element
    );
  }

  render() {
    const source = this.getDataSource();
    const end = this.getLastHour();
    const start = this.getFirstHour();

    return (
      <React.Fragment>
        <ModalDeleteBlocking connectionHub={this.state.connectionHub} stopSignalR={this.handleStopSignalR}/>
        <div className="headaer-filter-wrapper">
          <div className="header-filter-text-wrapper">
            <SelectBox
              label="Centros"
              Id="centros"
              searchEnabled
              placeholder="Listado de Centros"
              value={this.props.centerId}
              dataSource={this.props.centrosList}
              displayExpr="Description"
              valueExpr="Id"
              onValueChanged={this.handleChange}
            />
          </div>
          <div>
            <Button
              id="btnNuevaApertura"
              text="Agregar Bloqueo"
              type="success"
              onClick={() => this.handleStartSignalR()}
            >
            </Button>
          </div>
        </div>

        <div className="scheduler-wrapper" >

          {this.props.isPopupWizardOpen === true && (
            <ModalWizard
              startSignalR={this.handleStartSignalR}
              stopSignalR={this.handleStopSignalR}
              connectionHub={this.state.connectionHub}
            />
          )}
          <Scheduler
            className="blocking-view-month"
            dataSource={source}
            defaultCurrentView={this.currentView}
            defaultCurrentDate={new Date()}
            editing={{
              allowAdding: false,
              allowDragging: false,
              allowResizing: false,
              allowUpdating: false,
              allowDeleting: false,
            }}
            startDayHour={start}
            showAllDayPanel={false}
            showCurrentTimeIndicator={false}
            endDayHour={end}
            timeCellTemplate={(data, index, element) => {
              let { text } = data;
              if (data.text === "") {
                text = validaciones.getTimeForInterval(this.lastTimeInterval, defaultInterval);
              } else {
                this.lastTimeInterval = text;
              }
              ReactDOM.render(<span>{text}</span>, element);
            }}
            onAppointmentClick={this.handleAppointmentClick}
            cellDuration={defaultInterval}
            views={[
              /*{
                name: dia,
                type: "day",
                maxAppointmentsPerCell: "unlimited",
                appointmentTemplate: this.renderWeekItem,
              },
              {
                name: semana,
                type: "week",
                maxAppointmentsPerCell: "unlimited",
                appointmentTemplate: this.renderWeekItem,
              },*/
              {
                name: mes,
                type: "month",
                maxAppointmentsPerCell: "auto",
                appointmentTemplate: this.renderMonthItem,
                appointmentTooltipTemplate: this.renderMonthTooltip,
              },
            ]}
            onAppointmentDblClick={(e) => {
              e.cancel = true;
            }}
            onOptionChanged={this.handleOptionChange}
          />
        </div >
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  listaAppointments: state.bloqueosSel.listaAppointments,
  weekAppointments: state.bloqueosSel.weekAppointments,
  centrosList: state.bloqueosSel.centrosList,
  listQuotes: state.bloqueosSel.listQuotes,
  blocking: state.bloqueosSel.blocking,
  centerId: state.bloqueosSel.centerId,
  isPopupWizardOpen: state.bloqueosSel.isPopupWizardOpen,
  userData: state.global.userData,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(BlockingScheduler);
